import type { CleanedDeliveryBody, SourceCue } from "./types";

const COMMENT = /<!--[\s\S]*?-->/g;
const CUE = /^<!--\s*CUE:([A-Z_]+)\s*-->$/;

function lineNumberAt(source: string, offset: number): number {
  return source.slice(0, offset).split("\n").length;
}

function unescapeMarkdown(value: string): string {
  return value.replaceAll("\\_", "_").replaceAll("\\*", "*");
}

function normalizeLine(value: string): string {
  return unescapeMarkdown(value)
    .replace(/[\t ]+/g, " ")
    .trim();
}

export function toSpokenText(value: string): string {
  return stripMarkdownStrongEmphasis(value)
    .replaceAll("œ", "oe")
    .replaceAll("Œ", "Oe");
}

export function stripMarkdownStrongEmphasis(value: string): string {
  return value.replace(/\*\*([^*\r\n]+?)\*\*/g, "$1");
}

export function cleanDeliveryBody(body: string): CleanedDeliveryBody {
  const normalizedNewlines = body
    .replaceAll("\r\n", "\n")
    .replaceAll("\r", "\n");
  const cues: SourceCue[] = [];
  const withoutComments = normalizedNewlines.replace(
    COMMENT,
    (comment, offset: number) => {
      const cueMatch = CUE.exec(comment);
      if (cueMatch?.[1] !== undefined) {
        cues.push({
          name: cueMatch[1],
          sourceLine: lineNumberAt(normalizedNewlines, offset),
        });
      }

      return "\n".repeat(occurrences(comment, "\n"));
    },
  );
  const displayLines = withoutComments.split("\n").map(normalizeLine);
  const spokenLines = displayLines.map(toSpokenText);

  return { displayLines, spokenLines, cues };
}

function occurrences(source: string, value: string): number {
  return source.split(value).length - 1;
}
